import { useState } from "react";
import { ColorItem } from "./color-item";
import { HeartToggleButton } from "../save-color/heart-toggle-button";
import { SaveColorDropdown } from "../save-color/save-color-dropdown";
import { useCmsDeleteColor } from "../../../js/api/my-saved-colors/get-saved-colors";
import { useAddToColorCollectionModalStore } from "../../../js/stores/add-to-color-collection-modal-store";
import { addToBasketAction as basketFetchAction } from "../shared/add-to-basket-action";
import { TrendingBadge } from "./trending-badge";

export function LoggedInColorItem({
  name,
  rgb,
  colourCode,
  colourActions,
  selectedColors,
  setSelectedColors,
  isTrending,
}) {
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);
  const deleteCmsColorMutation = useCmsDeleteColor();
  const toggleClickHandler = () => {
    setIsSpinnerVisible(true);
    deleteCmsColorMutation.mutateAsync({
      url: colourActions?.removeAction?.linkUrl,
      successHandler: () => setIsSpinnerVisible(false),
      errorHandler: () => setIsSpinnerVisible(false),
    });
  };
  const openModal = useAddToColorCollectionModalStore(
    (state) => state.openModal
  );
  const addToBasketAction = colourActions?.addToBasketAction?.linkUrl
    ? {
        label: colourActions?.addToBasketAction?.linkLabel,
        clickHandler: () =>
          basketFetchAction(colourActions?.addToBasketAction?.linkUrl),
      }
    : null;
  const addToCollectionAction = colourActions?.addToCollectionAction?.linkUrl
    ? {
        label: colourActions?.addToCollectionAction?.linkLabel,
        clickHandler: () =>
          openModal(colourActions?.addToCollectionAction?.linkUrl),
      }
    : null;
  const removeAction = {
    label: colourActions?.removeAction?.linkLabel,
    clickHandler: () => toggleClickHandler(),
    disabled: isSpinnerVisible,
  };
  const actions = [
    addToBasketAction,
    addToCollectionAction,
    removeAction,
  ].filter((action) => !!action);

  return (
    <ColorItem
      name={name}
      rgb={rgb}
      colourCode={colourCode}
      selectedColors={selectedColors}
      setSelectedColors={setSelectedColors}
      actions={
        <>
          <HeartToggleButton
            isSaved={true}
            isLoading={isSpinnerVisible}
            disabled={isSpinnerVisible}
            toggleClickHandler={toggleClickHandler}
          />
          <SaveColorDropdown actions={actions} />
          {!!isTrending && <TrendingBadge />}
        </>
      }
    />
  );
}
